module.exports = __webpack_public_path__ + "static/media/icon-edit.da3169b2.svg";